function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/es/DropdownButton';
import DropdownItem from 'react-bootstrap/es/DropdownItem';
import { isEmpty, find, keys, uniq } from 'lodash';
import { SEARCH_TYPES } from "../constants";
import debouncedRequest from "../utils/debounce-search";
import SearchResults from "./search-results/search-results";

var SearchRow =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchRow, _Component);

  function SearchRow() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchRow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getValueOrDefault", function (artistsOrTracks) {
      return isEmpty(artistsOrTracks) ? {} : artistsOrTracks;
    });

    _defineProperty(_assertThisInitialized(_this), "getArtistsFromSearchResults", function (currentResults, artists) {
      return uniq(currentResults).map(function (artistId) {
        var resultKey = find(keys(artists), function (artistKey) {
          return RegExp("^artist".concat(artistId), 'g').test(artistKey);
        });
        return artists[resultKey];
      }).filter(function (result) {
        return result;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isSearchForTracks", function () {
      var artistsOrTracks = _this.props.artistsOrTracks;
      return artistsOrTracks === SEARCH_TYPES.TRACKS;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchStringChanging", function (inputValue) {
      var _this$props = _this.props,
          onSearchStringChanging = _this$props.onSearchStringChanging,
          onSearchRequest = _this$props.onSearchRequest;
      onSearchStringChanging(inputValue);
      debouncedRequest(inputValue, onSearchRequest, _this.isSearchForTracks());
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (payload) {
      var onSelect = _this.props.onSelect;
      onSelect(payload, _this.isSearchForTracks());
    });

    _defineProperty(_assertThisInitialized(_this), "searchName", function () {
      return _this.isSearchForTracks() ? SEARCH_TYPES.TRACKS : SEARCH_TYPES.ARTISTS;
    });

    _defineProperty(_assertThisInitialized(_this), "renderArtistsTracksDropdown", function () {
      var _this$props2 = _this.props,
          onArtistsTracksDropdownSelect = _this$props2.onArtistsTracksDropdownSelect,
          formatMessage = _this$props2.formatMessage,
          _this$props2$messages = _this$props2.messages,
          artistsLabel = _this$props2$messages.artistsLabel,
          tracksLabel = _this$props2$messages.tracksLabel;
      var title = _this.isSearchForTracks() ? formatMessage(tracksLabel) : formatMessage(artistsLabel);
      return React.createElement(DropdownButton, {
        className: "Filters",
        id: "Filters-search-wrapper-dropdown",
        onSelect: onArtistsTracksDropdownSelect,
        title: title
      }, React.createElement(DropdownItem, {
        eventKey: SEARCH_TYPES.ARTISTS,
        className: "Filters-dropdown-item-artist"
      }, formatMessage(artistsLabel)), React.createElement(DropdownItem, {
        divider: true
      }), React.createElement(DropdownItem, {
        eventKey: SEARCH_TYPES.TRACKS,
        className: "Filters-dropdown-item-track"
      }, formatMessage(tracksLabel)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearch", function () {
      var _this$props3 = _this.props,
          tags = _this$props3.tags,
          results = _this$props3.results,
          artists = _this$props3.artists,
          tracks = _this$props3.tracks,
          isLoading = _this$props3.isLoading,
          currentSearch = _this$props3.currentSearch,
          searchError = _this$props3.searchError,
          formatMessage = _this$props3.formatMessage,
          messages = _this$props3.messages;

      var searchName = _this.searchName();

      var currentResults = results ? results[currentSearch] : null;

      var allTracks = _this.getValueOrDefault(tracks);

      var allArtists = _this.getValueOrDefault(artists);

      var commonProps = {
        isLoading: isLoading,
        currentSearch: currentSearch,
        onInputChange: _this.handleSearchStringChanging,
        searchError: searchError,
        tags: tags,
        searchName: searchName,
        formatMessage: formatMessage,
        messages: messages,
        onChange: _this.handleSelect
      };
      var trackOrArtistResults;
      if (_this.isSearchForTracks()) trackOrArtistResults = currentResults ? currentResults.map(function (isrcUpc) {
        return allTracks[isrcUpc];
      }).filter(function (el) {
        return el;
      }) : [];else trackOrArtistResults = currentResults ? _this.getArtistsFromSearchResults(currentResults, allArtists) : [];
      return React.createElement(SearchResults, _extends({}, commonProps, {
        options: trackOrArtistResults
      }));
    });

    return _this;
  }

  _createClass(SearchRow, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "Filters-search-wrapper Filters-search-row"
      }, this.renderArtistsTracksDropdown(), this.renderSearch());
    }
  }]);

  return SearchRow;
}(Component);

_defineProperty(SearchRow, "propTypes", {
  results: PropTypes.object,
  artists: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  tracks: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  currentSearch: PropTypes.string,
  searchError: PropTypes.string,
  isLoading: PropTypes.bool,
  tags: PropTypes.array,
  artistsOrTracks: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.shape({
    artistsLabel: PropTypes.object,
    tracksLabel: PropTypes.object,
    searchResultsHeadingLabel: PropTypes.object,
    noMatchLabel: PropTypes.object,
    searchPlaceholderLabel: PropTypes.object,
    searchArtistsPlaceholderLabel: PropTypes.object,
    tryAgainLabel: PropTypes.object,
    temporaryErrorLabel: PropTypes.object,
    searchErrorLabel: PropTypes.object,
    checkSpellingLabel: PropTypes.object,
    releasedDateLabel: PropTypes.object,
    releaseNameLabel: PropTypes.object
  }).isRequired,
  onSearchStringChanging: PropTypes.func.isRequired,
  onSearchRequest: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onArtistsTracksDropdownSelect: PropTypes.func.isRequired
});

export { SearchRow as default };